import { Sparkles, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function ComingSoon({ title, description }) {
  return (
    <div data-testid="coming-soon-page" className="max-w-[900px] mx-auto pt-12">
      <div className="card-glass p-10 enter-up">
        <div className="flex items-center gap-2.5 mb-6">
          <div
            className="flex items-center justify-center rounded-md"
            style={{ width: 32, height: 32, background: "rgba(0, 194, 168, 0.10)", border: "1px solid rgba(0, 194, 168, 0.25)" }}
          >
            <Sparkles size={16} color="#00C2A8" />
          </div>
          <span
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              letterSpacing: "0.14em",
              color: "var(--accent-teal)",
              textTransform: "uppercase",
            }}
          >
            Next iteration
          </span>
        </div>

        <h1
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 800,
            fontSize: 32,
            letterSpacing: "-0.02em",
            color: "var(--text-primary)",
            marginBottom: 12,
          }}
        >
          {title}
        </h1>

        {description && (
          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: 15,
              lineHeight: 1.6,
              color: "var(--text-secondary)",
              maxWidth: 640,
              marginBottom: 24,
            }}
          >
            {description}
          </p>
        )}

        <div
          className="p-4 rounded-lg mb-6"
          style={{
            background: "rgba(14, 165, 233, 0.05)",
            border: "1px dashed rgba(14, 165, 233, 0.30)",
          }}
        >
          <div
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              color: "var(--text-secondary)",
              letterSpacing: "0.02em",
            }}
          >
            <span style={{ color: "#0EA5E9" }}>// STATUS:</span> Module scaffolded — full interactive
            experience ships next iteration alongside Dashboard telemetry.
          </div>
        </div>

        <Link
          to="/"
          data-testid="back-to-dashboard"
          className="inline-flex items-center gap-2 rounded-lg"
          style={{
            padding: "10px 16px",
            background: "transparent",
            border: "1px solid #00C2A8",
            color: "#00C2A8",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: 13,
            textDecoration: "none",
            transition: "background 150ms ease",
          }}
        >
          <ArrowLeft size={14} />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
